var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "991E7DD4-938A-4156-9E0E-C5F1C3A1BEC5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "17.1789588 0.5625 9.38999371 8.35146501 1.60102867 0.5625 0.5625 1.60102867 8.35146501 9.38999371 0.5625 17.1789588 1.60102867 18.2174875 9.38999371 10.4285224 17.1789588 18.2174875 18.2174875 17.1789588 10.4285224 9.38999371 18.2174875 1.60102867"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6_Automated-Execution",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Select-Files-screen-with-removed-files",
    transform: "translate(-1002.000000, -619.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upload-Button-/-File-Selected",
    transform: "translate(400.000000, 587.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xA9\\uFE0F-Icon/Outline/Close",
    transform: "translate(602.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Close",
    fill: "#333333",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83C\\uDFA8Color",
    mask: "url(#mask-2)",
    fill: "#7D7D7D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "#7D7D7D-Swatch",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseReport);
export default __webpack_public_path__ + "static/media/close-report.56a2822da09c0b8868f7672a53d51eff.svg";
export { ForwardRef as ReactComponent };